import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule, USE_EMULATOR } from '@angular/fire/firestore';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './iris/dashboard/dashboard.component';
import { SearchedBoardComponent } from './iris/searchedboard/searchedboard.component';
import { AboutusComponent } from './iris/aboutus/aboutus.component';
import { InfoDashboardComponent } from './iris/info-dashboard/info-dashboard.component';
import { VoiceDashboardComponent } from './iris/voice-dashboard/voice-dashboard.component';
import { KnowledgeDashboardComponent } from './iris/knowledge-dashboard/knowledge-dashboard.component';
import { SystemInfoComponent } from './iris/system-info/system-info.component';
import { ScholarshipComponent } from './iris/scholarship/scholarship.component';
import { PrivacyComponent } from './iris/privacy/privacy.component';
import { TermsComponent } from './iris/terms/terms.component';
import { FacilityArticleComponent } from './iris/facility-article/facility-article.component';
import { VoiceArticleComponent } from './iris/voice-article/voice-article.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SearchedBoardComponent,
    AboutusComponent,
    InfoDashboardComponent,
    VoiceDashboardComponent,
    KnowledgeDashboardComponent,
    PrivacyComponent,
    TermsComponent,
    FacilityArticleComponent,
    VoiceArticleComponent,
    SystemInfoComponent,
    ScholarshipComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule.enablePersistence(),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'ja',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FlexLayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatCardModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatListModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatTabsModule,
    MatRippleModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    OverlayModule,
  ],
  providers: [
    { provide: USE_EMULATOR, useValue: environment.useEmulators ? ['localhost', 8080] : undefined }
  ],
  entryComponents: [
    MatSpinner,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
